
  import { defineComponent, inject, ref, Ref } from 'vue';
  import { formItemDetailsFromWidgetKey } from '@/ui/injectionKeys';
  import { FormItemFilterRecord } from '@/services/api/resources/analytics-builder/model';

  export default defineComponent({
    name: 'FormItemTitle',
    setup() {
      const formItemDetail = inject<Ref<FormItemFilterRecord | undefined>>(formItemDetailsFromWidgetKey, ref());
      return {
        title: formItemDetail.value?.title,
      };
    },
  });
